import React, { useContext } from 'react';
import cn from 'classnames';
import { getDataTestId } from '../../../../shared/esm';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';
import '../../../../base-modal/esm';

var desktopStyles = {"size-500":"modal__size-500_11kz5","size-600":"modal__size-600_11kz5","size-800":"modal__size-800_11kz5","size-1140":"modal__size-1140_11kz5","fullscreen":"modal__fullscreen_11kz5"};
require('./desktop.css');

var styles = {"content":"modal__content_1swh3","withHeader":"modal__withHeader_1swh3","flex":"modal__flex_1swh3"};
require('./index.css');

var mobileStyles = {"content":"modal__content_1v2ue"};
require('./mobile.css');

var Content = function (_a) {
    var _b;
    var children = _a.children, flex = _a.flex, className = _a.className;
    var _c = useContext(ModalContext), contentRef = _c.contentRef, hasHeader = _c.hasHeader;
    var _d = useContext(ResponsiveContext), size = _d.size, view = _d.view, dataTestId = _d.dataTestId;
    return (React.createElement("div", { className: cn(styles.content, className, (_b = {},
            _b[styles.flex] = flex,
            _b[styles.withHeader] = hasHeader,
            _b[desktopStyles[SIZE_TO_CLASSNAME_MAP[size]]] = view === 'desktop' && size,
            _b[mobileStyles.content] = view === 'mobile',
            _b)), ref: contentRef, "data-test-id": getDataTestId(dataTestId, 'content') }, children));
};

export { Content };
